import { render, staticRenderFns } from "./outer_order_offert_detail.vue?vue&type=template&id=7b58db93&"
import script from "./outer_order_offert_detail.vue?vue&type=script&lang=js&"
export * from "./outer_order_offert_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports